import { useEffect, useState } from 'react';

export default function useElementHeight(ref) {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const element = ref.current;
    if (!element || typeof ResizeObserver === 'undefined') return undefined;

    const updateHeight = () => {
      setHeight(Math.ceil(element.getBoundingClientRect().height));
    };

    const observer = new ResizeObserver(updateHeight);
    observer.observe(element);
    updateHeight();
    return () => observer.disconnect();
  }, [ref]);

  return height;
}
